import Map from '@/components/Map.vue'
import weblink from '@/api/weblink'
import { helpers } from '@/helpers'
import { OPPORTUNITY_EXPORT_TYPES } from '@/constants'

export default {
  components: { Map },
  data () {
    return {
      isMenuToggle: false,
      isModalToggle: false,
      isLoggerToggle: false,
      showCover: true,

      termConditionsRead: false,
      // Contact form
      name: '',
      email: '',
      description: '',
      isSending: false,
      isCompleted: false,
      message: '',
      hash: '',
      vid: null,
      hasSignature: false,
      disableButton: false,
      signature: {
        id: null,
        parent: null,
        name: '',
        last_name: '',
        user_agent: '',
        payment_amount: '',
        traveler_email: '',
        number_of_guests: '',
        accepted_conditions: false,
        image: ''
      },
      option: {
        penColor: 'rgb(0, 0, 0)',
        backgroundColor: 'rgb(248, 247, 245)'
      },
      defaultUrl: ''
    }
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  mounted () {
    if (this.data && this.data.hash) {
      this.hash = this.data.hash
    }
    this.vid = document.querySelector('#videoLoop')
  },
  computed: {
    isNewPricing () {
      const params = new URLSearchParams(window.location.search)
      return params.has('p') || this.d.created_at >= '2026-07-14'
    },
    exportType () {
      if (this.data.isAgent) return OPPORTUNITY_EXPORT_TYPES.AGENT_WEBLINK.name
      return OPPORTUNITY_EXPORT_TYPES.WEBLINK.name
    },
    pricingItinerary () {
      if (this.data.isAgent) return this.d.itineraries.pricing_agent_itinerary
      return this.d.itineraries.pricing_itinerary
    },
    termsConditions () {
      if (this.data.isAgent) return this.d.itineraries.consumer_terms_conditions
      return this.d.itineraries.terms_conditions
    },
    t () {
      if (this.data && this.data.template) {
        return this.data.template
      }
      return {}
    },
    d () {
      if (this.data && this.data.data) {
        return this.data.data
      }
      return {}
    },
    locationsVisited () {
      if (
        this.d &&
        this.d.itineraries &&
        this.d.itineraries.locations_visited_coo
      ) {
        const locationsVisited = this.d.itineraries.locations_visited_coo
        return locationsVisited.filter(location => {
          return location.lat !== null || location.lng !== null
        })
      }
      return []
    },
    isLowerThanIE11 () {
      let detectIEregexp = ''
      if (navigator.userAgent.indexOf('MSIE') !== -1) {
        detectIEregexp = /MSIE (\d+\.\d+);/ // test for MSIE x.x
      } else {
        detectIEregexp = /Trident.*rv[ :]*(\d+\.\d+)/ // test for rv:x.x or rv x.x where Trident string exists
      }
      if (detectIEregexp.test(navigator.userAgent)) {
        let ieversion = Number(RegExp.$1)
        if (ieversion <= 11) {
          return true
        }
      }
      return false
    },
    firstOpporunityBackgroundImage () {
      return this.getBackgroundImageByIndex(0)
    },
    secondOpporunityBackgroundImage () {
      return this.getBackgroundImageByIndex(1)
    },
    thirdOpporunityBackgroundImage () {
      return this.getBackgroundImageByIndex(2)
    }
  },
  methods: {
    getBackgroundImageByIndex (index) {
      const field = this.data.isAgent ? 'agent_quote_web_link' : 'background'
      return helpers.getBackgroundImageByIndex(this.d.images, index, field)
    },
    checkTermConditionScroll (isModalToggle = false) {
      setTimeout(() => {
        if (isModalToggle) {
          const element = document.querySelector('#modal-terms-and-conditions-fullscreen .scrollable')
          this.termConditionsRead |= this.checkTermConditions(element)
        }
      }, 1000)
    },
    checkTermConditions (el) {
      return el.scrollTop + el.clientHeight >= el.scrollHeight - 5
    },
    handleTCScroll (evt) {
      const el = evt.target
      if (!el) return

      this.termConditionsRead |= this.checkTermConditions(el)
    },
    getParsedImageUrl (url) {
      const encodedUrl = encodeURI(url)
      const withoutSingleQuote = encodedUrl.replace(/'/g, '%27')
      return withoutSingleQuote
    },
    toggleCover () {
      this.showCover = !this.showCover
    },
    toggleMenu () {
      this.isMenuToggle = !this.isMenuToggle
    },
    toggleModal () {
      this.isModalToggle = !this.isModalToggle
      document.body.classList.toggle('modal-open', this.isModalToggle)
    },
    toggleLogger () {
      this.isLoggerToggle = !this.isLoggerToggle
    },
    scrollTo (id) {
      this.$scrollTo(`#${id}`, { duration: 800, offset: -60 })
    },
    menuScrollTo (id) {
      this.toggleMenu()
      this.scrollTo(id)
    },
    dayScrollTo (index) {
      this.toggleModal()
      setTimeout(() => {
        const config = {
          container: '#modal-fullscreen',
          duration: 0,
          offset: -60,
          force: true,
          easing: [0.0, 0.0, 0.0, 0.0]
        }
        this.$scrollTo(`#day${index}`, config)
      }, 0)

      // this.scrollTo('day' + index)
    },
    sendContactForm () {
      const payload = {
        name: this.name,
        email: this.email,
        description: this.description,
        hash: this.hash,
        uuid: this.$route.params.uuid
      }
      this.isSending = true
      this.isCompleted = false
      this.message = ''
      weblink
        .sendClientContact(payload)
        .then(response => {
          this.hash = response.data.hash // Refreshing a new hash from the response
          this.message = response.data.message
          this.isSending = false
          this.isCompleted = true
          this.cleanContactForm()
        })
        .catch(error => {
          this.message = error.response.data.message
          this.isSending = false
          this.isCompleted = true
          if (error.response.data.hash) {
            this.hash = error.response.data.hash
          }
        })
    },
    sendSignature (payload) {
      return weblink.sendSignature(payload)
    },
    cleanContactForm () {
      this.name = ''
      this.email = ''
      this.description = ''
    },
    playVideo (play = true) {
      if (!this.vid) {
        return false
      }
      var firstPlayVideo = document.querySelector('#firstPlayVideo')
      var firstSkipVideo = document.querySelector('#firstSkipVideo')
      firstPlayVideo.classList.toggle('hidePlease')
      this.vid.play()
      this.vid.addEventListener('ended', () => {
        firstSkipVideo.classList.toggle('hidePlease')
        this.toggleVideo()
        setTimeout(() => {
          this.vid.muted = true
          if (play) {
            this.vid.loop = true
            this.vid.play()
          }
        }, 500)
      })
    },
    skipVideo () {
      var firstPlayVideo = document.querySelector('#firstPlayVideo')
      var firstSkipVideo = document.querySelector('#firstSkipVideo')
      firstPlayVideo.classList.add('hidePlease')
      firstSkipVideo.classList.add('hidePlease')
      this.vid.pause()
      this.toggleVideo()
    },
    toggleVideo () {
      const els = document.querySelectorAll('.hidePlease')
      els.forEach(e => {
        if (e.type === 'button') {
          return false
        }
        e.classList.toggle('hidePlease')
      })
    },
    getSignature (id) {
      this.hasSignature = false
      return weblink
        .getSignature(id)
        .then(response => {
          if (response.status === 200 && response.data.status) {
            this.hasSignature = true
            this.disableButton = true
            this.signature.name = response.data.data[0].name
            this.signature.number_of_guests =
              response.data.data[0].number_of_guests
            this.signature.payment_amount = response.data.data[0].payment_amount
            this.signature.user_agent = response.data.data[0].user_agent
            this.signature.accepted_conditions = true
            this.defaultUrl = this.signature.user_agent
          }
        })
        .catch(() => {
          this.hasSignature = false
        })
    }
  }
}
